import { render, staticRenderFns } from "./environmentNews.vue?vue&type=template&id=4a769c68&scoped=true"
import script from "./environmentNews.vue?vue&type=script&lang=js"
export * from "./environmentNews.vue?vue&type=script&lang=js"
import style0 from "./environmentNews.vue?vue&type=style&index=0&id=4a769c68&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a769c68",
  null
  
)

export default component.exports